
<div v-show="profile" class="profile-list-item">
  <div class="profile-list-item-label">
    <h5 class="profile-list-item-label-top">
      {{ topLabel }}
    </h5>
    <h3 class="profile-list-item-label-middle">
      {{ middleLabel }}
    </h3>
    <grade-variation-chip
      v-if="bottomLabel"
      :variation="bottomLabel"
      no-color
    />
  </div>

  <div class="profile-list-item-right">
    <span v-if="!profile.hasMatches && profile.graderList && profile.graderList.length > 0" class="profile-list-item-grader">
      <span v-if="graderLogoSrc" class="profile-list-item-grader-pill">
        <img
          class="profile-list-item-grader-img"
          :src="graderLogoSrc"
          :alt="primaryGraderLabel"
        />
      </span>
      <pill v-else>
        {{ primaryGraderLabel }}
      </pill>
    </span>

    <icon v-else name="playlist_add_check" />

    <stat-item
      label="Total Population"
      :value="$filters.number(profile.totalPopulation)"
    />
  </div>
</div>
